/** Split view state — allows opening two routes side by side. */

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SplitPanel {
	id: string;
	path: string;
	title: string;
}

interface SplitViewState {
	/** Whether split mode is active. */
	isSplit: boolean;
	/** The secondary panel (primary is always the current route). */
	secondaryPanel: SplitPanel | null;
	/** Split direction. */
	direction: "horizontal" | "vertical";

	enableSplit: (panel: SplitPanel) => void;
	disableSplit: () => void;
	toggleSplit: () => void;
	setDirection: (dir: "horizontal" | "vertical") => void;
}

export const useSplitViewStore = create<SplitViewState>()(
	persist(
		(set, get) => ({
			isSplit: false,
			secondaryPanel: null,
			direction: "horizontal",

			enableSplit: (panel) => set({ isSplit: true, secondaryPanel: panel }),
			disableSplit: () => set({ isSplit: false, secondaryPanel: null }),
			toggleSplit: () => {
				const { isSplit } = get();
				if (isSplit) {
					set({ isSplit: false, secondaryPanel: null });
				} else {
					// When toggling on without a panel, duplicate current route
					set({ isSplit: true });
				}
			},
			setDirection: (direction) => set({ direction }),
		}),
		{
			name: "omnios-split-view",
			partialize: (s) => ({
				direction: s.direction,
			}),
		},
	),
);
